import {
   RiHeartFill,
   RiCheckboxCircleLine,
   RiMailLine,
   RiErrorWarningFill,
   RiHome5Line,
   RiHome5Fill,
   RiPieChartLine,
   RiPieChartFill,
   RiCouponLine,
   RiCouponFill,
   RiArrowLeftRightLine,
   RiArrowLeftRightFill,
   RiBankCardLine,
   RiBankCardFill,
   RiStore3Line,
   RiStore3Fill,
   RiUserLine,
   RiUserFill,
   RiGroupFill,
   RiLayoutGridLine,
   RiLayoutGridFill,
   RiCodeSSlashLine,
   RiCodeSSlashFill,
   RiPaletteLine,
   RiPaletteFill,
   RiCalendar2Fill,
   RiStarLine,
   RiStarFill,
   RiFileCopyLine,
   RiCloseLine,
   RiMore2Fill,
   RiEdit2Line,
   RiDeleteBin6Line,
   RiCheckboxCircleFill,
   RiArrowDownSFill,
   RiLoaderLine,
   RiLoader4Line,
   RiUploadCloudLine,
   RiBankLine,
   RiBankFill,
   RiEyeLine,
   RiEyeOffLine,
   RiMenuLine,
   RiLogoutBoxRLine,
   RiShieldUserLine,
   RiArrowUpLine,
   RiArrowDownLine,
   RiSubtractLine,
   RiSparklingLine,
   RiMenuFill,
   RiRouterLine,
   RiRouterFill,
   RiCustomerService2Line,
   RiSettings3Line,
   RiGlobalFill,
   RiGlobalLine,
   RiWallet3Line,
   RiShakeHandsLine,
   RiShoppingBag3Line,
   RiInformationLine,
   RiShieldCheckLine,
   RiChat3Line,
   RiChat3Fill,
} from '@remixicon/react';

// Create a map of available icons
export const ICONS_MAP = {
   sample: RiHeartFill,
   'arrow-down-s-fill': RiArrowDownSFill,
   'checkbox-circle-fill': RiCheckboxCircleFill,
   'delete-bin-6-line': RiDeleteBin6Line,
   'edit-2-line': RiEdit2Line,
   'more-2-fill': RiMore2Fill,
   'close-line': RiCloseLine,
   'file-copy-line': RiFileCopyLine,
   'star-line': RiStarLine,
   'star-fill': RiStarFill,
   'calendar-2-fill': RiCalendar2Fill,
   'heart-fill': RiHeartFill,
   'check-circle-line': RiCheckboxCircleLine,
   'mail-line': RiMailLine,
   'error-warning-fill': RiErrorWarningFill,
   'home-5-line': RiHome5Line,
   'home-5-fill': RiHome5Fill,
   'coupon-line': RiCouponLine,
   'coupon-fill': RiCouponFill,
   'arrow-left-right-line': RiArrowLeftRightLine,
   'arrow-left-right-fill': RiArrowLeftRightFill,
   'bank-card-line': RiBankCardLine,
   'bank-card-fill': RiBankCardFill,
   'store-3-line': RiStore3Line,
   'store-3-fill': RiStore3Fill,
   'user-line': RiUserLine,
   'user-fill': RiUserFill,
   'group-fill': RiGroupFill,
   'chat-3-line': RiChat3Line,
   'chat-3-fill': RiChat3Fill,
   'layout-grid-line': RiLayoutGridLine,
   'layout-grid-fill': RiLayoutGridFill,
   'code-s-slash-line': RiCodeSSlashLine,
   'code-s-slash-fill': RiCodeSSlashFill,
   'palette-line': RiPaletteLine,
   'palette-fill': RiPaletteFill,
   'loader-line': RiLoaderLine,
   'loader-4-line': RiLoader4Line,
   'upload-cloud-line': RiUploadCloudLine,
   'bank-line': RiBankLine,
   'bank-fill': RiBankFill,
   'eye-line': RiEyeLine,
   'eye-off-line': RiEyeOffLine,
   'menu-line': RiMenuLine,
   'logout-box-r-line': RiLogoutBoxRLine,
   'shield-user-line': RiShieldUserLine,
   'arrow-up-line': RiArrowUpLine,
   'arrow-down-line': RiArrowDownLine,
   'subtract-line': RiSubtractLine,
   'sparkling-line': RiSparklingLine,
   'menu-fill': RiMenuFill,
   'router-line': RiRouterLine,
   // Notification categories (Ray 2026-10-25)
   'wallet-3-line': RiWallet3Line,
   'shake-hands-line': RiShakeHandsLine,
   'shopping-bag-3-line': RiShoppingBag3Line,
   'information-line': RiInformationLine,
   'shield-check-line': RiShieldCheckLine,
   'router-fill': RiRouterFill,
   'pie-chart-line': RiPieChartLine,
   'pie-chart-fill': RiPieChartFill,
   'customer-service-2-line': RiCustomerService2Line,
   'settings-3-line': RiSettings3Line,
   // ISP Business: a globe, because the router icon already means Piso WiFi and
   // an operator switching products should not see the same mark twice.
   'global-fill': RiGlobalFill,
   'global-line': RiGlobalLine,
   loader: RiLoader4Line,
} as const; // `as const` ensures TypeScript treats these keys as literals

export type IconType = keyof typeof ICONS_MAP; // Extracts valid keys dynamically
